import { render, staticRenderFns } from "./product-range-list.vue?vue&type=template&id=5ecd916e"
import script from "./product-range-list.vue?vue&type=script&lang=js"
export * from "./product-range-list.vue?vue&type=script&lang=js"
import style0 from "./product-range-list.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports